import styled from 'styled-components';
import { IPromoted } from '../styles';
import { layout } from '@prisjakt/ui-base';
import StockStatusColumnComponent from '../../components/stock-status-column';

export const PriceColumn = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`;

export const GoToStoreColumn = styled.div<IPromoted>`
  margin: 0 ${layout.spacing.xxSmall};
  align-self: center;
  color: ${props => {
    return props.isPromoted
      ? props.theme.buttons.primary.bg
      : props.theme.buttons.positive.bg;
  }};
  display: flex;
`;

export const StockStatusColumn = styled(StockStatusColumnComponent)`
  margin: 0 ${layout.spacing.xSmall};
`;

export const ShippingColumn = styled.div`
  display: flex;
`;
